import InstanceStats from './InstanceStats';

export default InstanceStats;